/* SLIDE 18 */

import React, { useEffect, useState, useRef } from "react";
import SearchBar from "shared/components/SearchBar";
import SubHeader from "shared/components/SubHeader";
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getUnpaidList } from "features/parking/usecases/ParkingUsecases";
import { numberFormat, datetimeFormat } from "../../../utils/common";
import { setSearchUnpaid, setSelectedUnpaid } from "./store/parkingSlice";
import EmptySite from "shared/components/EmptySite";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "../../../shared/components/Loading";
import { ThreeDots } from 'react-loader-spinner';
import { setAppLoading } from "../../../shared/store/headerSlice";
import { set } from "react-hook-form";

const ParkingUnpaidList = () => {
    const { user } = useSelector((state) => state.auth);
    const { searchUnpaid } = useSelector((state) => state.parking);
    const { appLoading } = useSelector((state) => state.header);
    const [unpaidList, setUnpaidList] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(1);
    const [carNum, setCarNum] = useState(searchUnpaid || "");
    const [searchLoading, setSearchLoading] = useState(false);
    const [flag, setFlag] = useState(false);

    const scrollableRef = useRef(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();



    // Fetch unpaid list from API or state management
    const fetchUnpaidList = async (pageNum, carNum_) => {
        if (loading != 1 && searchLoading) {
            dispatch(setAppLoading(true));
        }
        try {
            if (pageNum == 1) {
                setUnpaidList([]);
            }
            const data = (carNum_ || carNum) ? {
                // parkingId: user.parkingId,
                carNumber: carNum_ || carNum || null,
                limit: 15,
                offset: pageNum,
            } : {
                // parkingId: user.parkingId,
                limit: 15,
                offset: pageNum,
            }
            const response = await getUnpaidList(data);
            // const unpaidListFilter = response?.unpaidList?.filter(unpaid => {
            //     console.log("unpaid", unpaid?.parkingEntry.payStatusCd);
            //     return unpaid?.parkingEntry.payStatusCd === "030"
            // });
            // console.log("unpaidListFilter", unpaidListFilter);
            setUnpaidList((prev) => [...prev, ...response?.unpaidList || []]);
            setTotalPages(response.totalPages);
            setHasMore(pageNum < response.totalPages);
            setLoading(prev => prev + 1);
        } catch (error) {
            console.error("Error fetching unpaid list:", error);
            setLoading(false);
        } finally {
            setSearchLoading(false);
            dispatch(setAppLoading(false));
        }

    };

    useEffect(() => {
        fetchUnpaidList(page, searchUnpaid);
    }, [page, flag]);

    useEffect(() => {
        return () => {
            setLoading(1);
        };
    }, []);

    const loadMore = () => {
        if (page < totalPages) {
            setPage((prev) => prev + 1);
        }
    };

    useEffect(() => {
        const checkHeight = () => {
            const container = scrollableRef.current;
            console.log("Container height:", container?.scrollHeight, window.innerHeight);
            if (container && container.scrollHeight <= (window.innerHeight - 180) && hasMore) {
                loadMore();
            }
        };
        checkHeight();
    }, [unpaidList, hasMore]);

    const refreshFunction = () => {
        setUnpaidList([]);
        setPage(1);
        setHasMore(true);
        setTotalPages(1);
        dispatch(setAppLoading(true));
        // setLoading(1);
        fetchUnpaidList(1);
    }

    const onRestartList = () => {
        setHasMore(false);
        setUnpaidList([]);

        setTimeout(() => {
            setSearchLoading(true);
            // dispatch(setAppLoading(true));
            setPage(1);
            setHasMore(true);
            setTotalPages(1);

            page == 1 && setFlag(prev => !prev); // Toggle flag to trigger useEffect
        }, 0);
    }
    const htFixedRef = useRef(null);
    useEffect(() => {
        const htFixedHeight = htFixedRef.current?.offsetHeight || 125;
        const filterHeight = document.querySelector('.pt-filter-height');
        if (filterHeight) {
            filterHeight.style.paddingTop = `${htFixedHeight}px`;
        }
        // console.log(htFixedHeight)
    }, [loading]);

    return (
        loading == 1 ?
            <ParkingUnpaidListSkeleton />
            :
            <>
                <div ref={htFixedRef} className="htFixed">
                    <SubHeader >
                        <div className={`sub-header-text w-full justify-between`} >
                            <div className="sub-header-text w-full" style={{ fontSize: '15px' }}>
                                <span className="htColorGray2">주차장명 : </span>
                                <span className="htBold">{`전체`}</span>
                            </div>
                            {/* <div className="nl-row" onClick={() => navigate("/parking_payment_wait_address")}>
                        <img src={searchIcon} alt="searchIcon" />
                        <span className="htColorGray ml-5" style={{fontSize: '14px'}}>주차장 검색</span>
                    </div> */}
                        </div>
                    </SubHeader>

                    <SearchBar
                        value={carNum}
                        onChange={(e) => {
                            setCarNum(e.target.value);
                            dispatch(setSearchUnpaid(e.target.value));
                        }}
                        handleSearchClick={() => {

                            onRestartList();
                        }}
                        onClear={() => {
                            setCarNum("");
                            dispatch(setSearchUnpaid(null));
                            onRestartList();

                        }}
                    />
                </div>
                <InfiniteScroll
                    dataLength={unpaidList.length}
                    ref={scrollableRef}
                    next={loadMore}
                    hasMore={hasMore}
                    loader={!appLoading && <div className="nl-row j-center pb-20"><Loading width="40" height="40" /></div>}
                    endMessage={
                        <p className="text-center htNoMore">
                            {unpaidList.length > 0 && page > 1 ? '더 이상 로드할 데이터가 없습니다.' : ''}
                        </p>
                    }
                    refreshFunction={refreshFunction}
                    pullDownToRefresh={true}
                    pullDownToRefreshThreshold={100}
                    pullDownToRefreshContent={
                        <div className="nl-row j-center pb-10 htNoMore">당겨서 새로고침...</div>
                    }
                    releaseToRefreshContent={
                        <div className="nl-row j-center a-center" style={{ height: 20, paddingBottom: '0px' }}>
                            <ThreeDots
                                visible={true}
                                height="40"
                                width="40"
                                color="#4fa94d"
                                radius="9"
                                ariaLabel="three-dots-loading"
                                wrapperClass="htThreeDots"
                            />
                        </div>
                    }

                    className="pb-20 pt-filter-height"

                >
                    <div className="pb-20" >



                        <div className="table-container bg-white">


                            <table className="parking-table mn-parking-table">
                                <thead>
                                    <tr>
                                        <th style={{ minWidth: "75px" }}>차량번호</th>
                                        <th style={{ minWidth: "75px" }}>입차일시</th>
                                        <th style={{ minWidth: "75px" }}>출차일시</th>
                                        <th style={{ minWidth: "auto" }}>미납금액</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {unpaidList?.map((item, index) => (
                                        <tr key={index} onClick={() => {
                                            dispatch(setSelectedUnpaid(item));
                                            navigate("/parking_unpaid_detail");
                                        }}>
                                            <td>{item.carNumber}</td>
                                            <td>
                                                <div className="flex flex-col">
                                                    <span>{datetimeFormat(item.inTime, "ISO", "yyyy-MM-dd")}</span>
                                                    <span>{datetimeFormat(item.inTime, "ISO", "HH:mm")}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="flex flex-col">
                                                    <span>{datetimeFormat(item.outTime, "ISO", "yyyy-MM-dd")}</span>
                                                    <span>{datetimeFormat(item.outTime, "ISO", "HH:mm")}</span>

                                                </div>
                                            </td>
                                            <td>
                                                {numberFormat(item.feeFinal)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {unpaidList.length === 0 && <EmptySite />}
                        </div>



                    </div>
                </InfiniteScroll>

            </>
    );
};

export default ParkingUnpaidList;

function ParkingUnpaidListSkeleton() {
    const rowCount = 12;
    const columnCount = 4;
    return (
        <div style={{ padding: '20px' }}>
            <Skeleton height={40} width={200} style={{ marginBottom: '20px' }} />

            <div style={{ marginBottom: '10px' }}>
                <Skeleton height={40} width="100%" />
            </div>

            <table className="pt-125" style={{ width: '100%', borderCollapse: 'collapse' }}>
                {/* <thead>
                    <tr>
                        <th>차량번호</th>
                        <th>입차일시</th>
                        <th>출차일시</th>
                        <th>미납금액</th>
                    </tr>
                </thead> */}
                <tbody>
                    {[...Array(rowCount)].map((_, rowIdx) => (
                        <tr key={rowIdx}>
                            {[...Array(columnCount)].map((_, colIdx) => (
                                <td key={colIdx} style={{ padding: '8px' }}>
                                    <Skeleton height={40} />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
